import ks from "./kBrowserShared";

/** Three decimals, as a string - enough for a curve the eye reads, for CSS, and for an easing
 *  string that stays short. A non-finite input collapses to "0"; a non-number input is coerced
 *  first (the layout emitter passes strings and relies on it). One home for the rounding the
 *  spring, the style and the layout emitters each used to spell out. */
export const KNum3 = (Value: any, OpLabel: string): string => {
    if (ks.KErrorMode === true) { return "0"; }
    try {
        const N: number = Number(Value);
        if (isFinite(N) === false) { return "0"; }
        return String(Math.round(N * 1000) / 1000);
    } catch (e) {
        ks.KGlobalErrorHandler(e, OpLabel);
        return "0";
    }
};
